export default __webpack_public_path__ + "static/media/integrity.1dea33e8.svg";